// extracted by mini-css-extract-plugin
export default {"container":"StatusButton_container__RFhkf","label":"StatusButton_label__rE2va"};